import { type RevisionType, REVISION_TYPES } from './types';

const REVISION_PREFIX = 'VALWIN_SBO_REVISION';

export const REVISION_HEADERS: Record<RevisionType, string> = {
  main: 'PSI-Expected-Revision',
  communication: 'x-psi-comm-revision',
  configuration: 'X-PSI-CONF-Revision',
  database: 'X-PSI-BDD-Revision',
  career: 'X-PSI-CAREER-Revision',
  forms: 'X-PSI-FORM-Revision',
  extranet: 'X-PSI-EXTRANET-Revision',
  group: 'PSI-GROUP-Expected-Revision',
};

export const getRevisionKey = (
  groupId: string,
  type: RevisionType = 'main'
): string => {
  // Legacy key format (`VALWIN_SBO_REVISION_EXTRANET_<groupId>`), kept so stored revisions stay readable
  const infix = type === 'main' ? '' : `_${type.toUpperCase()}`;

  return `${REVISION_PREFIX}${infix}_${groupId}`;
};

export const getStoredRevision = (
  groupId: string,
  type: RevisionType = 'main'
): string | null => {
  const value = localStorage.getItem(getRevisionKey(groupId, type));

  return value === 'null' ? null : value;
};

export const setStoredRevision = (
  groupId: string,
  revision: string | null,
  type: RevisionType = 'main'
): void => {
  const key = getRevisionKey(groupId, type);

  if (revision === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, revision);
  }
};

export const clearAllRevisions = (groupId: string): void => {
  REVISION_TYPES.forEach((type) =>
    localStorage.removeItem(getRevisionKey(groupId, type))
  );
};

export const clearAllTenantsRevisions = (): void => {
  const keys = Array.from({ length: localStorage.length }, (_, index) =>
    localStorage.key(index)
  );

  keys
    .filter((key): key is string => key?.startsWith(REVISION_PREFIX) ?? false)
    .forEach((key) => localStorage.removeItem(key));
};
